import { useEffect } from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router";

export function Auth({ location, data }) {
  const history = useHistory();
  const params = new URLSearchParams(location.search);
  const dataEnc = params.get("data");

  useEffect(() => {
    let dataParse = false;
    if (params && dataEnc) {
      dataParse = JSON.parse(atob(dataEnc));
      if (dataParse && dataParse.idrafam) {
        localStorage.setItem("data", JSON.stringify(dataParse));
        history.replace("/transporte");
      }
      if (dataParse && dataParse.idrafam === "0") {
        localStorage.setItem("data", JSON.stringify(dataParse));
        history.replace("/nuevo-contribuyente");
      }
    }

    if (data && data.idrafam) {
      localStorage.setItem("data", JSON.stringify(data));
      history.replace("/transporte");
    }
    if (data && data.idrafam === "0") {
      localStorage.setItem("data", JSON.stringify(data));
      history.replace("/nuevo-contribuyente");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const urlredirectprod = window.location.href;

  const authRenaper = () => {
    window.location.replace(
      `${process.env.REACT_APP_AUTH_URL}?ret=rctrenaper&vuelve=${urlredirectprod}`
    );
  };
  const authAnses = () => {
    window.location.replace(
      `${process.env.REACT_APP_AUTH_URL}?ret=rctanses&vuelve=${urlredirectprod}`
    );
  };
  const authAfip = () => {
    window.location.replace(
      `${process.env.REACT_APP_AUTH_URL}?ret=rctafip&vuelve=${urlredirectprod}`
    );
  };
  const authMiArgentina = () => {
    window.location.replace(
      `${process.env.REACT_APP_AUTH_URL}?ret=rctmiarg&vuelve=${urlredirectprod}`
    );
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <h3 className="mb-2"> INICIA SESIÓN</h3>{" "}
      <p className="mb-5">
        Para continuar con el trámite debes iniciar sesión con uno de estos
        servicios
      </p>
      <Button
        onClick={authAfip}
        style={{ width: "200px" }}
        variant="outline-primary"
        className="p-2 mb-4"
      >
        AFIP
      </Button>
      <Button
        onClick={authAnses}
        style={{ width: "200px" }}
        variant="outline-primary"
        className="p-2  mb-4"
      >
        ANSES
      </Button>
      <Button
        onClick={authRenaper}
        style={{ width: "200px" }}
        variant="outline-primary"
        className="p-2  mb-4"
      >
        RENAPER
      </Button>
      <Button
        onClick={authMiArgentina}
        style={{ width: "200px" }}
        variant="outline-primary"
        className="p-2 mb-4"
      >
        MI ARGENTINA
      </Button>
    </div>
  );
}
